export default "__VITE_ASSET__DYUjd0FN__"